import Key from "./Key";
import ReturnKey from "./ReturnKey";
import PropTypes from "prop-types";

const ControlStrip = ({
  className = "",
  appearance = "Light",
  hIndicator = false,
  type = "Default",
}) => {
  return (
    <div
      className={`w-[375px] relative h-[124px] text-center text-base text-light-text1 font-text-small ${className}`}
      data-appearance={appearance}
      data-hIndicator={hIndicator}
      data-type={type}
    >
      <img
        className="absolute top-[67px] left-[26px] w-8 h-8 overflow-hidden"
        loading="lazy"
        alt=""
        src="/icon--emoji.svg"
      />
      <img
        className="absolute top-[67px] left-[317px] w-8 h-8 overflow-hidden"
        loading="lazy"
        alt=""
        src="/icon--dictation.svg"
      />
      <div className="absolute top-[90px] left-[0px] w-[375px] h-[34px] hidden">
        <div className="absolute bottom-[8px] left-[calc(50%_-_66.5px)] rounded-81xl bg-light-text1 w-[134px] h-[5px]" />
      </div>
      <div className="absolute top-[0px] left-[0px] flex flex-row items-start justify-start p-10xs gap-1.5">
        <Key
          style="Small"
          showKey
          keyBorder="unset"
          keyPadding="unset"
          keyWidth="87.5px"
          keyFlex="unset"
          letter="123"
          letterTextTransform="unset"
          showIcon={false}
          iconLeft="calc(50% - 15.75px)"
        />
        <Key
          style="Small"
          showKey
          keyBorder="none"
          keyPadding="0"
          keyWidth="182px"
          keyFlex="unset"
          letter="space"
          letterTextTransform="unset"
          showIcon={false}
          iconLeft="calc(50% - 16px)"
        />
        <ReturnKey type="Default" />
      </div>
    </div>
  );
};

ControlStrip.propTypes = {
  className: PropTypes.string,

  /** Variant props */
  appearance: PropTypes.number,
  hIndicator: PropTypes.bool,
  type: PropTypes.number,
};

export default ControlStrip;
